import { Component, inject, ChangeDetectionStrategy, signal, ElementRef, HostListener } from '@angular/core';

import { TranslationService, Language } from '../../../core/services/translation.service';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [],
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageSelectorComponent {
  private readonly translationService = inject(TranslationService);
  private readonly elementRef = inject(ElementRef);

  readonly isOpen = signal(false);

  readonly currentLanguage = this.translationService.currentLanguage;
  readonly availableLanguages = this.translationService.availableLanguages;
  readonly currentConfig = this.translationService.currentConfig;

  toggleDropdown(): void {
    this.isOpen.update(v => !v);
  }

  closeDropdown(): void {
    this.isOpen.set(false);
  }

  selectLanguage(lang: Language): void {
    this.translationService.setLanguage(lang);
    this.closeDropdown();
  }

  getFlagEmoji(lang: Language): string {
    const flags: Record<Language, string> = {
      en: '🇺🇸',
      es: '🇪🇸',
      fr: '🇫🇷',
      de: '🇩🇪',
      zh: '🇨🇳',
      ja: '🇯🇵'
    };
    return flags[lang] || '🌐';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.isOpen() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.closeDropdown();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen()) {
      this.closeDropdown();
    }
  }
}